export default __webpack_public_path__ + "static/media/goals.1fefe76f.svg";